var csrf_token,
  railsHost = bsLib.railsHost(),
  signUpFormObj = {};

signUpFormObj.formContainer = document.querySelector(".open-source__container");
signUpFormObj.formObj = document.getElementById("open-source__form--sign-signup");
signUpFormObj.signOn = document.getElementById("google-sign-on-btn");
signUpFormObj.nameField = document.getElementById("user_full_name");
signUpFormObj.emailField = document.getElementById("user_email_login");
signUpFormObj.passwordField = document.getElementById("user_password");
signUpFormObj.tncField = document.getElementById("tnc_checkbox");
signUpFormObj.utf_no = document.getElementById("utf_no");
signUpFormObj.exclusive_pack = document.getElementById("exclusive_pack");
signUpFormObj.signinlink = document.getElementById("signinFormLink");
signUpFormObj.signuplink = document.getElementById("signupFormLink");
signUpFormObj.formHeader = document.getElementById("signupFormHeader");
signUpFormObj.signInGoogleOAuth = document.getElementById("google_sign_in_login_btn");

var nameElemt = signUpFormObj.formObj.querySelector(".user-full-name-input-placeholder"),
  tosElemt = signUpFormObj.formObj.querySelector(".checkout-tos"),
  submitElemt = document.getElementById("user_submit"),
  signinElem = signUpFormObj.formObj.querySelector(".signinform-link-elem"),
  signupElem = signUpFormObj.formObj.querySelector(".signupform-link-elem"),
  forgetBtn = signUpFormObj.formObj.querySelector(".open-source-forget-pass"),
  signInGoogleOAuthElem = signUpFormObj.formObj.querySelector(".google-login-button"),
  signOnElemt = signUpFormObj.signOn,
  currentPageUrl = window.location.href,
  previousPageUrl = document.referrer !== "" ? document.referrer : "organic",
  gauth_utm_campaigncode = bsLib.getParameterByName("utm_campaigncode") ? bsLib.getParameterByName("utm_campaigncode") : "";

//Add google sign on base64 encode
signUpFormObj.signOn.setAttribute(
  "href",
  signUpFormObj.signOn.getAttribute("href") +
    window.btoa(
      '{"open_source":"true","referrer_url":"' +
        currentPageUrl +
        '", ' +
        '"utm_campaigncode":"' +
        gauth_utm_campaigncode +
        '",' +
        '"primary_product":"' +
        pageProductName +
        '",' +
        '"page_url":"' +
        currentPageUrl +
        '",' +
        '"previous_page_url":"' +
        previousPageUrl +
        '"}'
    )
);

//Add google login btn for oauth on base64 encode
signUpFormObj.signInGoogleOAuth.setAttribute(
  "href",
  signUpFormObj.signInGoogleOAuth.getAttribute("href") +
    window.btoa(
      '{"open_source":"true","referrer_url":"' +
        currentPageUrl +
        '", ' +
        '"utm_campaigncode":"' +
        gauth_utm_campaigncode +
        '",' +
        '"primary_product":"' +
        pageProductName +
        '",' +
        '"page_url":"' +
        currentPageUrl +
        '",' +
        '"previous_page_url":"' +
        previousPageUrl +
        '"}'
    )
);

/**
 * Recaptcha File load
 */
window.addEventListener("load", function () {
  signUpForm.setCsrfToken(true);

  // load recaptcha JS after page load
  document.addEventListener("click", function () {
    var captchaFieldJS = document.getElementById("recaptcha-js");
    if (!captchaFieldJS && typeof grecaptcha === "undefined") {
      var scriptElm = document.createElement("script");
      scriptElm.setAttribute("id", "recaptcha-js");
      scriptElm.setAttribute("type", "text/javascript");
      scriptElm.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?ver=1.0"
      );
      scriptElm.setAttribute("defer", "defer");
      document.body.appendChild(scriptElm);

      signUpForm.setCsrfToken();
    }
  });
});

var signUpForm = (function (csrfToken, signUpFormObj) {
  return {
    init: init,
    resetForm: resetForm,
    validateFields: _validateFields,
    showError: _showError,
    setCsrfToken: setCsrfToken,
    loadingState: loadingState,
  };

  function setCsrfToken(async) {
    var asyncCall = async ? async : false;
    // XHR request for user token
    if (!csrf_token) {
      // XHR request for user token
      bsLib.ajax(
        "GET",
        railsHost + "/user/token.json",
        {},
        asyncCall,
        {},
        // Success message for user token.
        function (data) {
          var dataRequest = bsLib.JSONParse(data.response),
            authenticityToken = document.querySelectorAll(
              'input[name="authenticity_token"]'
            );

          for (var i = 0; i < authenticityToken.length; i++) {
            authenticityToken[i].value = dataRequest.csrf_token;
          }

          csrfToken = dataRequest.csrf_token;
          csrf_token = csrfToken;
        },
        // Custom Error message for user token.
        function () {
          return Messages.salesAndSupportPage.invalidUserToken;
        }
      );
    } else if (!csrfToken) {
      csrfToken = csrf_token;
    }
  }

  function init(isSignUpForm) {
    var action = signUpFormObj.formObj.getAttribute("action"),
      form_data = {
        utf8: signUpFormObj.utf_no.value,
        open_source: signUpFormObj.exclusive_pack.value,
        authenticity_token: csrf_token,
        utm_campaigncode: document
          .querySelector('[name="sfdc_utm_campaigncode"]')
          .value.trim(),
        additional_notes: document
          .querySelector('[name="additional_notes"]')
          .value.trim(),
        primary_product: document
          .querySelector('[name="primary_product"]')
          .value.trim(),
        secondary_product: document
          .querySelector('[name="secondary_product"]')
          .value.trim(),
        page_url: currentPageUrl,
        previous_page_url: previousPageUrl,
        captcha_v2_only: true,
      };

    if (isSignUpForm) {
      return new Promise(function (resolve, reject) {
        if (grecaptcha === undefined) {
          reject();
        }

        var grecaptchaResponse = grecaptcha.getResponse();
        if (!grecaptchaResponse) {
          reject();
        }

        form_data.terms_and_conditions = signUpFormObj.tncField.value;
        form_data["g-recaptcha-response"] = grecaptchaResponse;
        form_data.user = {
          full_name: signUpFormObj.nameField.value.trim(),
          email: signUpFormObj.emailField.value.trim(),
          password: signUpFormObj.passwordField.value,
          group_attributes: {
            name: "",
          },
        };
        form_data["ga_cid"] = bsLib.GAClientID();

        //sign up form
        // xhr request for sending form data
        bsLib.ajax(
          "POST",
          railsHost + action,
          JSON.stringify(form_data),
          false,
          //Form Header
          {
            "X-CSRF-Token": csrf_token,
            accept: "application/json",
            "content-type": "application/json; charset=utf-8", // Setting content type.
          },
          function (data) {
            //success
            var response = bsLib.JSONParse(data.response);
            if (response.success === true) {
              //success event
              WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
                form: "sign-up",
                action: "submit",
                success: "true",
              });

              //linkedin pixel
              if (window.lintrk !== undefined) {
                window.lintrk("track", { conversion_id: 9342745 });
              }

              if (
                typeof response.redirect === "string" ||
                typeof response.redirect_to === "string"
              ) {
                window.location = response.redirect || response.redirect_to;
              } else {
                window.location = generate_url("/dashboard", "live");
              }
            }
            resolve();
          },
          function (data) {
            //error
            var responseJson = bsLib.JSONParse(data.response),
              namerError = document.getElementById("name-error"),
              emailError = document.getElementById("email-error"),
              passwordError = document.getElementById("password-error");

            if (responseJson["full_name"] !== undefined) {
              _showError(
                signUpFormObj.nameField,
                namerError,
                "name-error",
                responseJson["full_name"]
              );
            }

            if (responseJson["email"] !== undefined) {
              _showError(
                signUpFormObj.emailField,
                emailError,
                "email-error",
                responseJson["email"]
              );
            }

            if (responseJson["password"] !== undefined) {
              _showError(
                signUpFormObj.passwordField,
                passwordError,
                "password-error",
                responseJson["password"]
              );
            }

            if (responseJson["error"] !== undefined) {
              if (
                responseJson["error"] ===
                "Please verify your account to continue."
              ) {
                window.location.href = generate_url(
                  "/confirmation",
                  "accounts"
                );
              } else {
                _showError(
                  signUpFormObj.passwordField,
                  passwordError,
                  "password-error",
                  Messages.signUpErrors.invalidPassword
                );
              }
            } else {
              new bsAlert({
                alertType: "error",
                timeout: false,
                text: responseJson["error"],
              });
            }

            reject();
          },
          true
        );

        grecaptcha.reset();
      });
    } else {
      if (action === "/users/sign_in") {
        form_data.user = {
          login: signUpFormObj.emailField.value.trim(),
          password: signUpFormObj.passwordField.value,
        };

        //sign in form
        //xhr request for sending form data
        bsLib.ajax(
          "POST",
          railsHost + action,
          JSON.stringify(form_data),
          false,
          //Form Header
          {
            "X-CSRF-Token": csrf_token,
            accept: "application/json",
            "content-type": "application/json; charset=utf-8", // Setting content type.
          },
          function (data) {
            //success
            var response = bsLib.JSONParse(data.response);
            if (response.success === true) {
              //success event
              WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
                form: "sign-in",
                action: "submit",
                success: "true",
              });

              if (
                typeof response.redirect === "string" ||
                typeof response.redirect_to === "string"
              ) {
                window.location = response.redirect || response.redirect_to;
              } else {
                window.location = generate_url("/dashboard", "live");
              }
            }
          },
          function (data) {
            //error
            var responseJson = bsLib.JSONParse(data.response),
              emailError = document.getElementById("email-error"),
              passwordError = document.getElementById("password-error");

            if (responseJson["email"] !== undefined) {
              _showError(
                signUpFormObj.emailField,
                emailError,
                "email-error",
                responseJson["email"]
              );
            }

            if (responseJson["password"] !== undefined) {
              _showError(
                signUpFormObj.passwordField,
                passwordError,
                "password-error",
                responseJson["password"]
              );
            }

            //Locked condition
            if (
              responseJson["locked"] !== undefined ||
              (typeof responseJson["attempts_left"] !== undefined &&
                responseJson["attempts_left"] <= 2)
            ) {
              new bsAlert({
                alertType: "error",
                timeout: false,
                text: responseJson["error"],
              });

              if (responseJson["locked"] !== undefined) {
                return;
              }
            }

            if (responseJson["error"] !== undefined) {
              if (
                responseJson["error"] ===
                "Please verify your account to continue."
              ) {
                window.location.href = generate_url(
                  "/confirmation",
                  "accounts"
                );
              } else {
                _showError(
                  signUpFormObj.passwordField,
                  passwordError,
                  "password-error",
                  Messages.signUpErrors.invalidPassword
                );
              }
            }
          },
          true
        );
      } else {
        //enterprise sso sign in form
        var sso_form_data = {
          utf8: signUpFormObj.utf_no.value,
          open_source: signUpFormObj.exclusive_pack.value,
          authenticity_token: csrf_token,
          email: signUpFormObj.emailField.value.trim(),
        };

        checkEmailExistenceInDB();

        //xhr request for sending form data
        bsLib.ajax(
          "POST",
          railsHost + action,
          sso_form_data,
          false,
          //Form Headers
          {
            "X-CSRF-Token": csrf_token,
            "content-type": "application/x-www-form-urlencoded; charset=utf-8", // Setting content type.
          },
          function (data) {
            //success
            var response = data.response,
              errorMsg,
              errorType,
              main_script;

            if (!response.includes("jQuery.bsAlert.alert")) {
              //success
              WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
                form: "sso-sign-in",
                action: "submit",
                success: "true",
              });

              main_script = document.createElement("script");
              main_script.append(response);
              document.getElementsByTagName("body")[0].appendChild(main_script);
            } else {
              //error type
              errorType = response
                .split("alertType: ")[1]
                .replace(/^\s+|\s+$/g, "");
              errorType = errorType.split("\n")[0];
              errorType = errorType.substring(0, errorType.lastIndexOf(","));
              errorType = errorType.replaceAll(/'/g, "");
              //error Msg
              response = response.split("text:")[1].replace(/^\s+|\s+$/g, "");
              response = response.replaceAll("%{root_url}", "/");
              errorMsg = response.split("\n")[0];
              errorMsg = errorMsg.substring(0, errorMsg.lastIndexOf(","));
              errorMsg = errorMsg.replaceAll(/'/g, "");

              new bsAlert({
                alertType: errorType,
                timeout: 5000,
                htmlMessage: true,
                text: errorMsg,
              });

              return false;
            }
          },
          function () {},
          false
        );
      }
    }
  }

  function _validateFields() {
    var formValid = true,
      action = signUpFormObj.formObj.getAttribute("action"),
      mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/,
      namerError = document.getElementById("name-error"),
      emailError = document.getElementById("email-error"),
      passwordError = document.getElementById("password-error"),
      emailFieldVal = signUpFormObj.emailField.value.trim();

    //clear error if exists
    signUpFormObj.emailField.classList.remove("error-border");
    signUpFormObj.emailField.removeAttribute("aria-describedby");
    if (emailError) {
      emailError.remove();
    }

    //email
    if (emailFieldVal == "" || !emailFieldVal.match(mailformat)) {
      var domain = emailFieldVal.substring(emailFieldVal.lastIndexOf("@") + 1);

      if (
        emailFieldVal.indexOf("@") === -1 ||
        emailFieldVal.indexOf(".") === -1 ||
        emailFieldVal.indexOf("..") !== -1 ||
        bsLib.emailContainsNonLatinCharacters(emailFieldVal) ||
        !(
          emailFieldVal.indexOf("+") > -1 &&
          (domain == "browserstack.com" || domain == "percy.io")
        )
      ) {
        formValid = _showError(
          signUpFormObj.emailField,
          emailError,
          "email-error",
          Messages.emailValidationErrors.invalidEmail
        );
      }
    }

    if (action !== "/enterprise/sign_in") {
      //password
      if (signUpFormObj.passwordField.value.length < 6) {
        formValid = _showError(
          signUpFormObj.passwordField,
          passwordError,
          "password-error",
          Messages.signUpErrors.passwordLength
        );
      } else {
        signUpFormObj.passwordField.classList.remove("error-border");
        signUpFormObj.passwordField.removeAttribute("aria-describedby");
        if (passwordError) {
          passwordError.remove();
        }
      }
    }

    if (action === "/users") {
      //name
      if (signUpFormObj.nameField.value.trim().length < 3) {
        formValid = _showError(
          signUpFormObj.nameField,
          namerError,
          "name-error",
          Messages.signUpErrors.fullNameLength
        );
      } else {
        signUpFormObj.nameField.classList.remove("error-border");
        signUpFormObj.nameField.removeAttribute("aria-describedby");
        if (namerError) {
          namerError.remove();
        }
      }

      //terms and conditions
      if (!signUpFormObj.tncField.checked && formValid) {
        formValid = false;
        new bsAlert({
          alertType: "error",
          htmlMessage: true,
          text: Messages.signUpErrors.termsAndConditions,
        });
      }
    }

    return formValid;
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    if (fieldError) {
      fieldError.remove();
    }
    fieldName.classList.remove("error-border");
    fieldName.insertAdjacentHTML(
      "afterend",
      '<div class="error-message" id="' +
        errorName +
        '"><div class="msg-body"><span>' +
        errorMessage +
        "</span></div></div>"
    );
    fieldName.classList.add("error-border");
    fieldName.setAttribute("aria-describedby", errorName);
  }

  function generate_url(appendRoute, subdomain) {
    var url = "https://";
    if (subdomain) {
      url += subdomain + ".";
    }
    url += window.location.hostname.replace(/^[^.]+\./g, "");
    if (appendRoute) {
      url += appendRoute;
    }
    return url;
  }

  function resetForm() {
    signUpFormObj.formObj.reset(); //Reset form
  }

  function loadingState(loadedState, loadingText) {
    if (signUpFormObj.formContainer) {
      signUpFormObj.loadingContainer =
        signUpFormObj.formContainer.querySelector(".loading-container");
    }

    if (signUpFormObj.loadingContainer) {
      if (loadedState) {
        signUpFormObj.loadingContainer.style.display = "none";
      } else {
        signUpFormObj.loadingContainer.style.display = "block";
      }
    }
    if (submitElemt) {
      if (loadedState) {
        submitElemt.classList.remove("disabled");
        submitElemt.value = loadingText ? loadingText : "Submit";
      } else {
        submitElemt.classList.add("disabled");
        submitElemt.value = loadingText ? loadingText : "Please wait...";
      }
    }
  }
})(csrf_token, signUpFormObj);

//check user email on blur event
signUpFormObj.emailField.addEventListener("blur", checkEmailExistenceInDB);
function checkEmailExistenceInDB(event) {
  var validEmail = true,
    that = document.getElementById("user_email_login"),
    action = signUpFormObj.formObj.getAttribute("action"),
    mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/,
    emailError = document.getElementById("email-error"),
    emailFieldVal = that.value.trim();

  //clear error if exists
  that.classList.remove("error-border");
  that.removeAttribute("aria-describedby");
  if (emailError) {
    emailError.remove();
  }

  if (emailFieldVal == "" || !emailFieldVal.match(mailformat)) {
    var domain = emailFieldVal.substring(emailFieldVal.lastIndexOf("@") + 1);

    if (
      emailFieldVal.indexOf("@") === -1 ||
      emailFieldVal.indexOf(".") === -1 ||
      emailFieldVal.indexOf("..") !== -1 ||
      bsLib.emailContainsNonLatinCharacters(emailFieldVal) ||
      !(
        emailFieldVal.indexOf("+") > -1 &&
        (domain == "browserstack.com" || domain == "percy.io")
      )
    ) {
      validEmail = signUpForm.showError(
        that,
        emailError,
        "email-error",
        Messages.emailValidationErrors.invalidEmail
      );
    }
  }

  if (validEmail) {
    signUpForm.setCsrfToken();
    var checkEmail = new Promise(function (resolve, reject) {
      bsLib.ajax(
        "POST",
        railsHost + "/user/check_email",
        JSON.stringify({
          name: emailFieldVal,
          authenticity_token: csrf_token,
        }),
        false,
        {
          "X-CSRF-Token": csrf_token,
          accept: "application/json",
          "content-type": "application/json; charset=utf-8", // Setting content type.
        },
        function (data) {
          var dataRequest = bsLib.JSONParse(data.response);

          if (!dataRequest.exists) {
            showSignUpStateElem();
          } else if (dataRequest.exists && !dataRequest.is_sso_group) {
            showSignInStateElem();
            if (dataRequest.oauth_type) {
              //show google oAuth login button and hide submit button
              signUpFormObj.formObj.classList.add("open-source__google-oauth-main");
            } else {
              if (sessionStorage.getItem("setSessionEmailExistKey") === null) {
                new bsAlert({
                  alertType: "info",
                  htmlMessage: true,
                  text: "Hooray! The email exists. Enter your password to start testing.",
                });
                sessionStorage.setItem("setSessionEmailExistKey", "1");
              }
            }
          } else if (dataRequest.exists && dataRequest.is_sso_group) {
            signUpFormObj.formObj.setAttribute("action", "/enterprise/sign_in");
            signUpFormObj.formObj.classList.remove("open-source__google-oauth-main");
            signUpFormObj.formObj.classList.add("open-source__container__enterprise");
            signUpFormObj.formHeader.innerHTML = "Single Sign-On";
          }
          resolve("Sign me in");
        },
        function () {
          reject();
        },
        true
      );
    });
    checkEmail.finally(function (btn_text) {
      signUpForm.loadingState(true, btn_text);
    });
  }
}

//google button click
signUpFormObj.signOn.addEventListener("click", function (e) {
  var action = signUpFormObj.formObj.getAttribute("action");
  //Form interaction event
  if (action === "/users") {
    WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
      form: "sso-sign-up",
      action: "click",
    });
  } else {
    WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
      form: "sso-sign-in",
      action: "click",
    });
  }
});

//Sign up submit
signUpFormObj.formObj.addEventListener("submit", function (e) {
  e.preventDefault();

  removeErrorMsgField(true);

  var action = this.getAttribute("action");
  //Form interaction event
  if (action === "/users") {
    WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
      form: "sign-up",
      action: "click",
    });
  } else if (action === "/enterprise/sign_in") {
    WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
      form: "sso-sign-in",
      action: "click",
    });
  } else {
    WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
      form: "sign-in",
      action: "click",
    });
  }

  if (!signUpForm.validateFields()) {
    return false;
  }

  signUpForm.setCsrfToken();

  var recaptchaElemt = document.querySelectorAll(".g-recaptcha");
  for (var i = 0; i < recaptchaElemt.length; i++) {
    recaptchaElemt[i].classList.remove("error");
    if (recaptchaElemt[i].querySelector("span")) {
      recaptchaElemt[i].querySelector("span").remove();
    }
  }

  if (action === "/users") {
    if (typeof grecaptcha !== "undefined") {
      grecaptcha.execute();
    }
  } else {
    signUpForm.init(false);
  }

  return false;
});

//Switch to signin state
signUpFormObj.signinlink.addEventListener("click", function (event) {
  event.stopPropagation();
  removeErrorMsgField();
  showSignInStateElem();
});

//Switch to signup state
signUpFormObj.signuplink.addEventListener("click", function (event) {
  event.stopPropagation();
  removeErrorMsgField();
  showSignUpStateElem();
  signUpFormObj.tncField.checked = false;
});

function removeErrorMsgField(keepValue) {
  var inputFieldsElem = signUpFormObj.formObj.querySelectorAll(
    ".custom-input-field"
  );
  for (var i = 0; i < inputFieldsElem.length; i++) {
    inputFieldsElem[i].classList.remove("error-border");
    inputFieldsElem[i].removeAttribute("aria-describedby");
    if (!keepValue) {
      inputFieldsElem[i].value = "";
    }
    if (inputFieldsElem[i].nextSibling) {
      inputFieldsElem[i].nextSibling.remove();
    }
  }
}

function showSignInStateElem() {
  signUpFormObj.formObj.setAttribute("action", "/users/sign_in");
  signUpFormObj.formObj.classList.remove("open-source_container__enterprise");
  signUpFormObj.formObj.classList.remove("open-source_container__google-oauth-main");
  signUpFormObj.formHeader.innerHTML = "Get Started";
  //name field
  if (nameElemt) {
    nameElemt.classList.remove("show");
    nameElemt.classList.add("hide");
  }

  //signin link elem
  if (signinElem) {
    signinElem.classList.remove("show");
    signinElem.classList.add("hide");
  }

  //signup link elem
  if (signupElem) {
    signupElem.classList.remove("hide");
    signupElem.classList.add("show");
  }

  //terms of services
  if (tosElemt) {
    tosElemt.classList.remove("show");
    tosElemt.classList.add("hide");
  }

  //update button value
  if (submitElemt) {
    submitElemt.setAttribute("value", "Sign me in");
  }

  //google sign on button
  if (signOnElemt) {
    signOnElemt.lastElementChild.innerHTML = "Sign in with Google";
  }
  //Forget password btn
  if(forgetBtn){
    forgetBtn.classList.remove('hide');
    forgetBtn.classList.add('show');
  }
}

function showSignUpStateElem() {
  signUpFormObj.formObj.setAttribute("action", "/users");
  signUpFormObj.formObj.classList.remove("open-source__enterprise");
  signUpFormObj.formObj.classList.remove("open-source__google-oauth-main");
  signUpFormObj.formHeader.innerHTML = "Create a FREE Account";
  //name field
  if (nameElemt) {
    nameElemt.classList.remove("hide");
    nameElemt.classList.add("show");
  }

  //signin link elem
  if (signinElem) {
    signinElem.classList.remove("hide");
    signinElem.classList.add("show");
  }

  //signup link elem
  if (signupElem) {
    signupElem.classList.remove("show");
    signupElem.classList.add("hide");
  }

  //terms of services
  if (tosElemt) {
    tosElemt.classList.remove("hide");
    tosElemt.classList.add("show");
  }

  //update button value
  if (submitElemt) {
    submitElemt.setAttribute("value", "Sign me up");
  }

  //google sign on button
  if (signOnElemt) {
    signOnElemt.lastElementChild.innerHTML = "Sign up with Google";
  }

  //Forget password btn
  if(forgetBtn){
    forgetBtn.classList.remove('show');
    forgetBtn.classList.add('hide');
  }
}